/*
 * Copyright (c) Nexign, JSC, 2020-2023.
 */
/**
 * init Translation Wizard Product Offerings
 *
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @author Evgeniy Naumov
 * @author Ilya Baranchikov
 * @version 1.27.0
 * @since 1.10.0
 */

import { ETextBlockStatus } from '../../../../components/common/TextBlockStatus/textBlockStatusTypes';
import {
    EProductSubscribersActivationListField,
    EProductSubscribersTableField,
    EWizardProductOfferingsSteps,
} from '../../../../pages/WizardProductOfferings/wizardProductOfferingsConstants';
import { IWizardProductOfferingsTranslation } from '../../types';
import { initWizardPropsTranslation } from './initWizardTranslation';

export const initWizardProductOfferingsTranslation: IWizardProductOfferingsTranslation = {
    ...initWizardPropsTranslation,
    [EWizardProductOfferingsSteps.StepSelectSubscribers]: {
        info: '',
        regionNoticeHtml: '',
        title: '',
    },
    [EWizardProductOfferingsSteps.StepSelectDate]: {
        dateFromLabel: '',
        dateToLabel: '',
        dateToOffLabel: '',
        infoHtmlConnect: '',
        infoHtmlConnectWithRoamingProducts: '',
        infoHtmlDisconnect: '',
        infoHtmlDisconnectWithRoamingProducts: '',
    },
    [EWizardProductOfferingsSteps.StepSelectMegaPowers]: {
        megaPowersListError: '',
    },
    [EWizardProductOfferingsSteps.StepConfirmation]: {
        activateStatus: {
            [ETextBlockStatus.ERROR]: '',
            [ETextBlockStatus.OK]: '',
            [ETextBlockStatus.PARTIALLY]: '',
            [ETextBlockStatus.WARNING]: '',
            [ETextBlockStatus.CHANGE]: '',
        },
        deactivateStatus: {
            [ETextBlockStatus.ERROR]: '',
            [ETextBlockStatus.OK]: '',
            [ETextBlockStatus.PARTIALLY]: '',
            [ETextBlockStatus.WARNING]: '',
            [ETextBlockStatus.CHANGE]: '',
        },
        recoveryToList: '',
        removedFromList: '',
        subscriberActivationListTitles: {
            [EProductSubscribersActivationListField.ACCOUNT_NUMBER]: '',
            [EProductSubscribersActivationListField.COST]: '',
            [EProductSubscribersActivationListField.INFO]: '',
            [EProductSubscribersActivationListField.MSISDN]: '',
            [EProductSubscribersActivationListField.STATUS]: '',
        },
        additionalWarnings: {
            megaPowersCanBeChanged: '',
            costWarning: '',
        },
    },
    table: {
        [EProductSubscribersTableField.ACCOUNT]: {
            header: '',
        },
        [EProductSubscribersTableField.ACTION_CONFLICTS]: {
            header: '',
        },
        [EProductSubscribersTableField.COST]: {
            header: '',
        },
        [EProductSubscribersTableField.LABELS]: {
            header: '',
        },
        [EProductSubscribersTableField.MSISDN]: {
            header: '',
        },
        [EProductSubscribersTableField.NAME]: {
            header: '',
        },
        [EProductSubscribersTableField.RATE_PLAN]: {
            header: '',
        },
    },
    validateErrors: {
        fillNotify: '',
        selectOneSubscribers: '',
        selectSubscribers: '',
        selectSuccessSubscribers: '',
        selectDate: '',
    },
    wizardModalSuccess: {
        mainPage: '',
        orderMessageEndConnectService: '',
        orderMessageEndConnectTariff: '',
        orderMessageEndDisconnectService: '',
        orderPage: '',
        productsPage: '',
        inquiry: {
            suggestAccept: '',
            suggestText: '',
            suggestTitle: '',
        },
        inquiryPage: '',
        inquiryMessageStart: '',
        inquiryMessageEnd: '',
    },
    wizardReport: {
        email: '',
        header: '',
        phone: '',
        toSubscribers: '',
        toUser: '',
    },
    wizardSummary: {
        activationTitle: '',
        activationServices: '',
        megaPowersToActivate: '',
        megaPowersToDeactivate: '',
        dateFrom: '',
        dateTo: '',
        deactivationTitle: '',
        deactivationServices: '',
        showLess: '',
        showMore: '',
        subscribersAmount: '',
        totalCost: '',
    },
};
